(function () {
  const TIERS = (BYO_CONFIG.tiers || []).slice().sort((a, b) => a - b);
  const DISCOUNTS = BYO_CONFIG.discounts || {};

  const state = {
    items: [],
    maxSlots: Math.max(...TIERS)
  };

  let els = {};

  /* =============================
     INIT
  ============================= */
  function init() {
    cache();
    bind();
    initTabs();
    updateUI();
  }

  /* =============================
     CACHE DOM
  ============================= */
  function cache() {
    els = {
      addBtns: document.querySelectorAll('.byo-add-btn'),
      checkoutBtns: document.querySelectorAll('.byo-checkout'),
      filterTabs: document.querySelectorAll('.byo-filter-tab'),
      productCards: document.querySelectorAll('.byo-product-card'),
      itemImages: document.querySelector('.byo-item-images'),
      milestoneSteps: document.querySelectorAll('.byo-milestone-step'),
      productsAwayText: document.querySelector('.js-products-away'),
      discountText: document.querySelectorAll('.js-discount'),
      discountTextLeft: document.querySelectorAll('.js-discount-left'),
      finalPrices: document.querySelectorAll('.js-final-price'),
      comparePrices: document.querySelectorAll('.js-compare-price')
    };
  }

  /* =============================
     EVENTS
  ============================= */
  function bind() {

    /* ---- QTY + / − ---- */
    document.addEventListener('click', (e) => {
      const plusBtn = e.target.closest('.qty-plus');
      const minusBtn = e.target.closest('.qty-minus');

      if (!plusBtn && !minusBtn) return;

      const card = e.target.closest('.byo-product-card');
      if (!card) return;

      const input = card.querySelector('.qty-number');
      let qty = parseInt(input.value, 10) || 1;
      const remaining = state.maxSlots - state.items.length;

      if (plusBtn && qty < remaining) {
        input.value = qty + 1;
      }

      if (minusBtn) {
        input.value = Math.max(1, qty - 1);
      }
    });

    /* ---- ADD ITEMS ---- */
    els.addBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-disabled')) return;

        const card = btn.closest('.byo-product-card');
        const qtyInput = card.querySelector('.qty-number');
        let qty = parseInt(qtyInput.value, 10) || 1;

        const remaining = state.maxSlots - state.items.length;
        qty = Math.min(qty, remaining);

        for (let i = 0; i < qty; i++) {
          state.items.push({
            id: btn.dataset.id,
            price: parseFloat(btn.dataset.price),
            image: btn.dataset.image
          });
        }

        qtyInput.value = 1;

        btn.classList.add('is-added');
        btn.textContent = 'ADDED';

        setTimeout(() => {
          btn.textContent = '+ ADD';
          btn.classList.remove('is-added');
        }, 700);

        updateUI();
      });
    });

    /* ---- CHECKOUT ---- */
    els.checkoutBtns.forEach(btn => {
      btn.addEventListener('click', handleCheckout);
    });
  }

  /* =============================
     UI UPDATE
  ============================= */
  function updateUI() {
    const qty = state.items.length;

    /* ---- FILL SLOTS ---- */
    const slots = els.itemImages.querySelectorAll('.byo-item-image');

    slots.forEach((slot) => {
      const step = parseInt(slot.dataset.step, 10);
      if (!step || step < 1 || step > state.maxSlots) return;

      const index = step - 1;
      const item = state.items[index];

      const svg = slot.querySelector('svg');
      const img = slot.querySelector('.byo-filled-img');
      const remove = slot.querySelector('.byo-remove');

      slot.classList.remove('is-filled');
      if (img) img.remove();
      if (remove) remove.remove();
      if (svg) svg.style.visibility = '';

      if (item) {
        const image = document.createElement('img');
        image.src = item.image;
        image.className = 'byo-filled-img';

        const removeBtn = document.createElement('div');
        removeBtn.className = 'byo-remove';
        removeBtn.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 2.25C6.62 2.25 2.25 6.62 2.25 12s4.37 9.75 9.75 9.75 9.75-4.37 9.75-9.75S17.38 2.25 12 2.25Zm3.53 13.28-3.53-3.47-3.53 3.47a.75.75 0 1 1-1.06-1.06l3.47-3.53-3.47-3.53a.75.75 0 1 1 1.06-1.06l3.53 3.47 3.53-3.47a.75.75 0 1 1 1.06 1.06l-3.47 3.53 3.47 3.53a.75.75 0 1 1-1.06 1.06Z" fill="white"/></svg>`;

        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          state.items.splice(index, 1);
          updateUI();
        });

        slot.appendChild(image);
        slot.appendChild(removeBtn);
        slot.classList.add('is-filled');
        if (svg) svg.style.visibility = 'hidden';
      }
    });

    /* ---- DISABLE ADD BUTTONS ---- */
    els.addBtns.forEach(btn => {
      btn.disabled = qty >= state.maxSlots;
      btn.classList.toggle('is-disabled', qty >= state.maxSlots);
    });

    /* ---- STEPS ACTIVE ---- */
    els.milestoneSteps.forEach(step => {
      const stepNum = parseInt(step.dataset.step, 10);
      step.classList.toggle('is-active', stepNum <= qty);
    });

    /* ---- DYNAMIC DISCOUNT LOGIC ---- */
    let discount = 0;
    let currentTier = 0;
    let nextTier = null;

    TIERS.forEach(tierQty => {
      if (qty >= tierQty) {
        currentTier = tierQty;
        discount = DISCOUNTS[tierQty] || 0;
      }
    });

    for (let i = 0; i < TIERS.length; i++) {
      if (qty < TIERS[i]) {
        nextTier = TIERS[i];
        break;
      }
    }

    let savingsText = `${Math.round(discount * 100)}%`;
    let leftDiscount = '0%';
    let productsAway = 0;

    if (nextTier) {
      const nextDiscount = DISCOUNTS[nextTier] || 0;
      leftDiscount = `${Math.round(nextDiscount * 100)}%`;
      productsAway = nextTier - qty;
    } else {
      leftDiscount = savingsText;
      productsAway = 0;
    }

    /* ---- APPLY TEXT ---- */
    els.discountText.forEach(el => {
      el.textContent = savingsText;
    });

    els.discountTextLeft.forEach(el => {
      el.textContent = leftDiscount;
    });

    els.productsAwayText.textContent = productsAway;

    /* ---- PRICE ---- */
    const baseTotal = state.items.reduce((sum, item) => sum + item.price, 0);
    const finalTotal = baseTotal * (1 - discount);

    els.finalPrices.forEach(el => {
      el.textContent = `$${finalTotal.toFixed(2)}`;
    });

    els.comparePrices.forEach(el => {
      if (discount > 0) {
        el.textContent = `$${baseTotal.toFixed(2)}`;
        el.style.display = 'inline';
      } else {
        el.style.display = 'none';
      }
    });
  }

  /* =============================
     FILTER TABS
  ============================= */
  function initTabs() {
    els.filterTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        els.filterTabs.forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');

        const collection = tab.dataset.collection;

        els.productCards.forEach(card => {
          card.style.display =
            card.dataset.collection === collection ? 'block' : 'none';
        });
      });
    });
  }

  /* =============================
     CHECKOUT
  ============================= */
  function handleCheckout() {
    const items = state.items.map(item => ({
      id: item.id,
      quantity: 1
    }));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    }).then(() => {
      window.location.href = '/checkout';
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
